import React from 'react';
import './Contact.css';

function Contact() {
  return (
    <div className="contact-container">
      <div className="contact-header">
        <h1>Contact Us</h1>
        <p>Get in touch with our team</p>
      </div>
      
      <div className="contact-content">
        <div className="contact-info">
          <h2>Contact Information</h2>
          <div className="contact-item">
            <h3>Email</h3>
            <a href="mailto:contact@example.com" className="no-context-menu">contact@example.com</a>
          </div>
          <div className="contact-item">
            <h3>Phone</h3>
            <a href="tel:+1234567890" className="exclude-context">+1 (234) 567-8900</a>
          </div>
          <div className="contact-item">
            <h3>Address</h3>
            <p>123 Business Street<br />City, State 12345</p>
          </div>
        </div>
        
        <div className="contact-links">
          <h2>Quick Links</h2>
          <ul>
            <li><a href="/support" data-exclude-menu="true">Support Center</a></li>
            <li><a href="/faq">FAQ</a></li>
            <li><a href="/documentation" className="no-context-menu">Documentation</a></li>
            <li><a href="/community">Community Forum</a></li>
          </ul>
        </div>
        
        <div className="external-links">
          <h2>External Resources</h2>
          <ul>
            <li><a href="https://github.com/example" target="_blank" rel="noopener noreferrer">GitHub</a></li>
            <li><a href="https://twitter.com/example" target="_blank" rel="noopener noreferrer" className="exclude-context">Twitter</a></li>
            <li><a href="https://linkedin.com/company/example" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Contact;
